<template>
  <v-app>

    <v-container id="navbar" style="position: fixed; top: 0; z-index: 100; width: 100%" class="pa-0" fluid>
      <v-row class="ma-0">
        <div v-if="browserIsIE" class="browser-warn-banner">
          <div class="browser-warn-banner-text">
            <v-icon color="white" size="32pt">warning</v-icon> Internet Explorer wird nicht mehr unterstützt.
            Bitte nutzen Sie <a target="_blank" href="https://www.google.com/intl/de_ALL/chrome/">Chrome</a>, <a href="https://www.mozilla.org/‎" target="_blank">Firefox</a>,
            <a href="https://www.microsoft.com/de-de/windows/microsoft-edge" target="_blank">Edge</a> oder <a href="https://www.opera.com/de" target="_blank">Opera</a>.
          </div>
        </div>

        <!-- Header /-->
        <site-header v-if="showHeader" id="dmbHeader"/>
        <!-- Menu /-->
        <site-menu-toolbar id="dmbToolbar" :small-screen="!showHeader"/>
      </v-row>

    </v-container>

    <v-btn v-if="$vuetify.breakpoint.width > 1439" id="scrollupbutton"
           :ripple="false"
           fab
           fixed
           bottom
           right
           class="scroll-up-button round-corners"
           @click="scrollToTop"
    > <v-icon color="primary">arrow_upward</v-icon>
    </v-btn>

    <v-container :class="{ 'authenticated': $store.getters.isAuthenticated, 'small-screen': !showHeader}"
                 class="appcontainer pa-0"
                 fluid>
      <!-- Content -->
      <!--breakpoint-indicator/-->
      <v-content :class="{ 'content-box': true, 'content-box-wide': isYoligWideLayout}">
        <div id="contentInner" class="content-inner">

          <slot/>
        </div>
      </v-content>

      <!-- Footer -->
      <site-footer/>

    </v-container>
  </v-app>
</template>

<script>
import SiteHeader from "@/components/SiteHeader";
import SiteMenuToolbar from "@/components/SiteMenuToolbar";
import SiteFooter from "@/components/SiteFooter";
export default {
  name: "SiteLayoutDefault",
  components: {
    SiteHeader,
    SiteMenuToolbar,
    SiteFooter
  },
  computed: {
    browserIsIE: function() {
      return !!window.MSInputMethodContext && !!document.documentMode;
    },
    showHeader() {
      return this.$vuetify.breakpoint.width > 1100 && this.$vuetify.breakpoint.height > 800;
    },
    isYoligWideLayout() {
      if (this.$router.currentRoute.path === '/privatkunden' && this.$store.getters.activeStepNumberPrivat === 2
        && this.$store.getters.showYoligMatrix('b') && this.$store.getters.isSusAvailable && !this.$store.state.b.nurnachhaltig) {
        return true;
      }
      if (this.$router.currentRoute.path.startsWith('/aenderungsantrag') && this.$store.getters.activeStepNumberAenderung === 2
        && this.$store.getters.showYoligMatrix('editContract') && this.$store.getters.isSusAvailable && !this.$store.state.editContract.nurnachhaltig) {
        return true;
      }
      return false;
    }
  },
  methods: {
    scrollToTop: function () {
      window.scrollTo(0, 0);
    }
  }
};

/**
 * This code adjusts the scrolling behaviour of fixed elements
 * dmb-menu-content
 */

let scrollButtonState = 'up';
function setScrollButton (scrollDirection) {
  if (scrollButtonState === scrollDirection) return;
  let scrollBtn = document.getElementById("scrollupbutton");
  if (scrollBtn) {
    let scrollPosition = window.pageYOffset;
    if (scrollDirection === 'up' && scrollPosition <= 500) {
      scrollBtn.classList.remove("scroll-up-button-appear");
      scrollBtn.classList.add("scroll-up-button-disappear");
      scrollButtonState = 'up';
    } else if (scrollPosition > 500) {
      scrollBtn.classList.remove("scroll-up-button-disappear");
      scrollBtn.classList.add("scroll-up-button-appear");
      scrollButtonState = 'down';
    }
  }
}

let contentPositionState = 'up';
function setContentPosition (scrollDirection) {
  if (contentPositionState === scrollDirection) return;
  let up = scrollDirection === 'up';

  document.getElementById("navbar").classList.remove(up ? 'scroll-down-navbar' : 'scroll-up-navbar');
  document.getElementById("navbar").classList.add(up ? 'scroll-up-navbar' : 'scroll-down-navbar');
  document.getElementById("contentInner").classList.remove(up ? 'scroll-down' : 'scroll-up');
  document.getElementById("contentInner").classList.add(up ? 'scroll-up' : 'scroll-down');

  let activeMenu = document.getElementsByClassName("dmb--toolbar--menu menuable__content__active")[0];
  if (activeMenu) {
    let content = activeMenu.getElementsByClassName("menu-content-open")[0];
    if (up) content.style.top = "136px";
    content.classList.remove(up ? 'scroll-down-navbar' : 'scroll-up-navbar');
    content.classList.add(up ? 'scroll-up-navbar' : 'scroll-down-navbar');
  }

  let stepper = document.getElementById("custom-header-stepper");
  if (stepper) {
    stepper.classList.remove(up ? "scroll-down-stepper" : "scroll-up-stepper");
    stepper.classList.add(up ? "scroll-up-stepper" : "scroll-down-stepper");
  }

  let quicknav = document.getElementById("custom-header-quicknav");
  if (quicknav) {
    quicknav.classList.remove(up ? "scroll-down-quicknav" : "scroll-up-quicknav");
    quicknav.classList.add(up ? "scroll-up-quicknav" : "scroll-down-quicknav");
  }
  let sumBox = document.getElementById("summary-box");
  if (sumBox === null) {
    sumBox = document.getElementById("gewerbe-summary-box");
  }
  if (sumBox) {
    sumBox.classList.remove(up ? "scroll-down-navbar" : "scroll-up-navbar");
    sumBox.classList.add(up ? "scroll-up-navbar" : "scroll-down-navbar");
  }

  let contactBox = document.getElementById("contact-box");
  if (contactBox) {
    contactBox.style.top = up ? "152px" : "92px";
  }

  let menus = document.getElementsByClassName("menu-content-open");
  Array.prototype.forEach.call(menus, function(menu) {
    menu.classList.remove(up ? 'scroll-down-navbar' : 'scroll-up-navbar');
    menu.classList.add(up ? 'scroll-up-navbar' : 'scroll-down-navbar');
  });

  contentPositionState = scrollDirection;
}

window.onresize = function() {
    // Workaround Patch for resizing issue: Idea is to reset scroll down behavior after resizing
  setContentPosition('up');
};

let prevScrollpos = window.pageYOffset;
window.onscroll = function() {
  let currentScrollPos = window.pageYOffset;
  let scrollDirection = prevScrollpos > currentScrollPos ? 'up' : 'down';

  if (!window.DMB_NO_SCROLL_EFFECTS) {
    let smallScreen = !document.getElementById("dmbHeader");
    let loggedOut = !document.getElementById("dmbToolbar");

    setScrollButton(scrollDirection);
    if (!smallScreen && !loggedOut) setContentPosition(scrollDirection);
  }

  prevScrollpos = currentScrollPos;
};

</script>
<style>
.v-application.theme--light {
  background-color: #FFFFFF !important;
}
.appcontainer.authenticated {
  margin-top: 136px;
}

.appcontainer:not(.authenticated) {
  margin-top: 88px;
  border-top: solid 2px rgba(0,0,0,.12);
}

.appcontainer.small-screen.authenticated, .appcontainer.small-screen:not(.authenticated) {
  margin-top: 48px;
  border-top: none;
}

.browser-warn-banner {
  position: fixed;
  top: 0;
  z-index: 100;
  background-color: darkorange;
  color: white;
  width: 100%;
  height: 88px;
}

.browser-warn-banner-text {
  margin: 28px auto;
  max-width: 1184px;
  font-size: 14pt;
  text-align: center;
}

.content-box {
  /* 1280px for YOLIG wider */
  max-width: 1280px!important;
  margin: auto;
}

@media screen and (min-width: 1505px) {
  .content-box-wide {
    max-width: 1530px!important;
  }
}

.content-inner {
  padding: 0px 0px 0px 0px;
}

.scroll-up-button {
  position: fixed !important;
  bottom: 100px !important;
  right: 52px !important;
  z-index: 8 !important;
  display: none;
  background-color: #f5f5f5!important;
}
#scrollupbutton:not(:hover):before {
  opacity: 0!important;
}

.scroll-up-button-appear {
  animation: appear-button;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  -moz-animation-timing-function: ease-out;
  display: block;
}

.scroll-up-button-disappear {
  animation: disappear-button;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  -moz-animation-timing-function: ease-out;
  display: block;
}

.scroll-up-navbar {

  animation: appear-navbar;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-iteration-count: 1;
  -moz-animation-timing-function: ease-out;
}

.scroll-down-navbar {

  animation: disappear-navbar;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-iteration-count: 1;
  -moz-animation-timing-function: ease-out;
}

.scroll-down-stepper {
  top: 136px;
  animation: scroll-down-stepper;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -moz-animation-timing-function: ease-out;
}

.scroll-up-stepper {
  top: 136px;
  animation: scroll-up-stepper;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -moz-animation-timing-function: ease-out;
}

.scroll-down-quicknav {
  top: 136px;
  animation: scroll-down-quicknav;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -moz-animation-timing-function: ease-out;
}

.scroll-up-quicknav {
  top: 136px;
  animation: scroll-up-quicknav;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -moz-animation-timing-function: ease-out;
}

/* The animation code */
@keyframes scroll-up-stepper {
  from {transform: translateY(-88px);}
  to {transform: translateY(0);}
}

/* The animation code */
@keyframes scroll-down-stepper {
  from {transform: translateY(0);}
  to {transform: translateY(-88px);}
}
/* The animation code */
@keyframes scroll-up-quicknav {
  from {transform: translateY(-88px);}
  to {transform: translateY(0);}
}

/* The animation code */
@keyframes scroll-down-quicknav {
  from {transform: translateY(0);}
  to {transform: translateY(-88px);}
}

/* The animation code */
@keyframes appear-navbar {
  from {transform: translateY(-88px);}
  to {transform: translateY(0);}
}

/* The animation code */
@keyframes disappear-navbar {
  from {transform: translateY(0);}
  to {transform: translateY(-88px);}
}

/* The animation code */
@keyframes appear-button {
  from {transform: scale(0);}
  to {transform: scale(1)}
}

/* The animation code */
@keyframes disappear-button {
  from {transform: scale(1);}
  to {transform: scale(0);}
}
</style>

